module.exports = __webpack_public_path__ + "img/Inspiration_Abdruck.e00a6e69.jpg";